import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LoadingContainer } from "../components/loading-container.js";
import { firebaseFetchPostFeed } from "../redux/firebase.js";
import useLanguage from "../redux/use-language.js";
import Pagination from "../components/pagination.js";

const FeedPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPosts, setTotalPosts] = useState(1);
  const { language } = useLanguage();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["feed", language, currentPage],
    queryFn: () => firebaseFetchPostFeed(language, currentPage),
    staleTime: Infinity,
  });

  useEffect(() => {
    if (data) {
      setTotalPages(data.totalPages);
      setTotalPosts(data.totalPosts);
    }
  }, [data]);

  if (isLoading || isFetching) return <LoadingContainer />;

  return (
    <div className="feed-page">
      {data.posts.map((post, j) => (
        <div key={j} className="card p-4 flex flex-col mb-4">
          <div className="text-lg font-semibold">
            <Link className="tripLink" to={`/${language}/post/${post.id}`}>{post.title}</Link>
          </div>
          <div className="text-xs text-slate-500 mt-0.5">{post.date}</div>
          <div className="mt-2 text-slate-600 text-[0.9375rem] leading-relaxed" dangerouslySetInnerHTML={{ __html: post.preview.replace(/\n/g, "<br/>") }}></div>
          <div className="mt-2">
            <Link className="tripLink text-sm" to={`/${language}/post/${post.id}`}>
              {language === "en" ? "Read more..." : "Читать дальше..."}
            </Link>
          </div>
        </div>
      ))}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalPosts}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default FeedPage;
